import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Http from "../Common/Http";
import IsLogin from "../Common/IsLogin";
import { setUserType } from "../Common/Permission";

const Login = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [message, setMessage] = useState();
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const formSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    Http.post("/login", inputs)
      .then((res) => {
        console.log(res.data);
        // drop the previous user's cached type before the new one is fetched
        setUserType("");
        localStorage.setItem("token", res.data.token);
        sessionStorage.setItem("token", res.data.token);
        window.location.href = "/dashboard";
      })
      .catch(function (e) {
        setMessage(e.response.message);
        setLoading(false);
      });
  };

  return (
    <div className="login-page">
      <IsLogin></IsLogin>
      <div className="animated-background">
        <div className="dots-overlay"></div>
        <div className="glow-effect"></div>
      </div>
      <div className="login-container">
        <div className="login-panel">
          <div className="left-panel">
            <div className="logo-container">
              <div className="">
                {/* <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                  <circle cx="25" cy="25" r="23" stroke="#f0c14b" strokeWidth="2"/>
                  <path d="M15 25L22 32L35 18" stroke="#f0c14b" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg> */}
                <img
                  src="assets/img/logo.webp"
                  alt="NABIL"
                  className="logo-image w-50"
                />
              </div>
              {/* <h1 className="brand-title">NABIL</h1>
              <p className="brand-tagline">HIGHWAY RESTAURANT</p> */}
            </div>
            <div className="welcome-section">
              <h2 className="welcome-title">Welcome Back</h2>
              <p className="welcome-subtitle">
                Manage your supply chain with ease
              </p>
            </div>
          </div>
          <div className="right-panel">
            <div className="login-form-container">
              <h2 className="form-title">Sign In</h2>
              {message && <div className="error-message">{message}</div>}
              <form onSubmit={formSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <div className="input-wrapper">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-input"
                      onChange={handleChange}
                      placeholder="admin@nabil.com"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="label-row">
                    <label htmlFor="password">Password</label>
                    <a href="#" className="forgot-link">
                      Forgot password?
                    </a>
                  </div>
                  <div className="input-wrapper">
                    <input
                      type="password"
                      id="password"
                      name="password"
                      className="form-input"
                      onChange={handleChange}
                      placeholder="Enter your password"
                      required
                    />
                  </div>
                </div>
                <button type="submit" className="login-btn" disabled={loading}>
                  {loading ? (
                    <div className="button-loader">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  ) : (
                    "Sign In"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .login-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
          position: relative;
          overflow: hidden;
          font-family: 'Poppins', sans-serif;
        }
        
        .animated-background {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }
        
        .dots-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: radial-gradient(circle at 20px 20px, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
          background-size: 40px 40px;
          animation: drift 20s linear infinite;
          pointer-events: none;
        }
        
        .glow-effect {
          position: absolute;
          top: -50%;
          right: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(138, 43, 226, 0.1) 0%, transparent 50%);
          animation: glow 8s ease-in-out infinite alternate;
          pointer-events: none;
        }
        
        @keyframes drift {
          0% { transform: translate(0, 0); }
          100% { transform: translate(-40px, -40px); }
        }
        
        @keyframes glow {
          0% { opacity: 0.3; transform: scale(1); }
          100% { opacity: 0.6; transform: scale(1.1); }
        }
        
        .login-container {
          width: 90%;
          max-width: 1000px;
          z-index: 10;
          position: relative;
        }
        
        .login-panel {
          display: flex;
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          border: 1px solid rgba(255, 255, 255, 0.1);
          min-height: 600px;
        }
        
        .left-panel {
          flex: 1;
          background:  linear-gradient(135deg,rgba(79,70,229,.2),rgba(124,58,237,.2));
          padding: 60px 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          color: white;
          position: relative;
        }
        
        .left-panel::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: radial-gradient(circle at 30px 30px, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
          background-size: 60px 60px;
          opacity: 0.3;
        }
        
        .logo-container {
          margin-bottom: 24px;
        }
        
        .logo-circle {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          animation: pulse 2s ease-in-out infinite;
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        
        .brand-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin: 0 0 10px 0;
          color: #f0c14b;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        }
        
        .brand-tagline {
          font-size: 1rem;
          margin: 0;
          opacity: 0.9;
          letter-spacing: 2px;
        }
        
        .welcome-section {
          position: relative;
          z-index: 2;
        }
        
        .welcome-title {
          font-size: 1.8rem;
          font-weight: 600;
          margin: 0 0 10px 0;
        }
        
        .welcome-subtitle {
          font-size: 1rem;
          margin: 0;
          opacity: 0.8;
        }
        
        .right-panel {
          flex: 1;
          padding: 60px 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0, 0, 0, 0.2);
        }
        
        .login-form-container {
          width: 100%;
          max-width: 350px;
        }
        
        .form-title {
          font-size: 2rem;
          font-weight: 600;
          margin: 0 0 30px 0;
          color: #ffffff;
          text-align: center;
        }
        
        .error-message {
          background: rgba(244, 63, 94, 0.15);
          border: 1px solid rgba(244, 63, 94, 0.3);
          color: #fecdd3;
          padding: 12px;
          border-radius: 8px;
          margin-bottom: 20px;
          text-align: center;
          font-size: 0.9rem;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .label-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
        }
        
        label {
          display: block;
          margin-bottom: 8px;
          color: #ffffff;
          font-weight: 500;
          font-size: 0.9rem;
        }
        
        .forgot-link {
         color: #ffffff;
          text-decoration: none;
          font-size: 0.85rem;
          transition: color 0.3s ease;
        }
        
        .forgot-link:hover {
         
          text-decoration: underline;
        }
        
        .input-wrapper {
          position: relative;
        }
        
        .form-input {
          width: 100%;
          padding: 15px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 10px;
          font-size: 1rem;
          background: rgba(255, 255, 255, 0.07);
          color: #fff;
          transition: all 0.3s ease;
        }
        
        .form-input::placeholder {
          color: rgba(255, 255, 255, 0.4);
        }
        
        .form-input:focus {
          outline: none;
          border-color: #8a2be2;
          box-shadow: 0 0 0 3px rgba(138, 43, 226, 0.1);
          background: rgba(255, 255, 255, 0.1);
        }
        
        .login-btn {
          width: 100%;
          padding: 15px;
          background: linear-gradient(135deg,#4f46e5,#7c3aed);
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 10px;
          position: relative;
          overflow: hidden;
        }
        
        .login-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: all 0.6s ease;
        }
        
        // .login-btn:hover {
        //   transform: translateY(-2px);
        //   box-shadow: 0 10px 20px rgba(138, 43, 226, 0.3);
        // }
        
        .login-btn:hover::before {
          left: 100%;
        }
        
        .login-btn:active {
          transform: translateY(0);
        }
        
        .button-loader {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
        }
        
        .button-loader span {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: white;
          animation: bounce 1.4s infinite ease-in-out both;
        }
        
        .button-loader span:nth-child(1) {
          animation-delay: -0.32s;
        }
        
        .button-loader span:nth-child(2) {
          animation-delay: -0.16s;
        }
        
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }
        
        @media (max-width: 768px) {
          .login-panel {
            flex-direction: column;
            max-width: 400px;
            margin: 0 auto;
          }
          
          .left-panel {
            padding: 40px 20px;
          }
          
          .right-panel {
            padding: 40px 20px;
          }
          
          .brand-title {
            font-size: 2rem;
          }
          
          .welcome-title {
            font-size: 1.5rem;
          }
        }
        
        @media (prefers-reduced-motion: reduce) {
          .dots-overlay,
          .glow-effect,
          .logo-circle,
          .login-btn::before {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
};

export default Login;

